var AISErrorsCodes = {
    20000: 'Success',
    90001: 'Missing key identify',
    90002: 'Incorrect key indentify',
    90003: 'Missing parameter',
    90004: 'Incorrect parameter',
    90005: 'System Error',
    90006: 'Permission deny',
    90007: 'Connection Error',
    90008: 'Connection Timeout',
    90009: 'This service is privilege for AIS customers',
    90010: 'This service is privilege for AIS customers',
    90011: 'Unknown format',
    90014: 'Response Not JSON format',
    40101: 'Access denied',
    90099: 'Unknown Error'
};

export { AISErrorsCodes };
